//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const dates = ref(['2019-09-10', '2019-09-20'])

    return {
      dates,
    }
  },
}
